export type ProfileId = 'cognitive' | 'visual' | 'motor';

export type FontSizeId = 'normal' | 'large' | 'xlarge';

export type HistoryMode = 'summary' | 'easyRead' | 'describe' | 'motorNote';

export const PROFILE_IDS: ProfileId[] = ['cognitive', 'visual', 'motor'];

export const FONT_SIZE_IDS: FontSizeId[] = ['normal', 'large', 'xlarge'];

export const AVAILABLE_PROFILES: ProfileId[] = ['cognitive', 'visual', 'motor'];
